import { useState } from "react"
import SecondaryText from "../../../components/general/BaseOutlineText"
import BaseSection from "../../../components/layout/BaseSection"
import { motion } from "framer-motion"
import { API } from "../../../api/api"

type FoundersType = {
    image_niklas: {
        data: {
            attributes: {
                url: string
            }
        }
    }
    image_felix: {
        data: {
            attributes: {
                url: string
            }
        }
    }
}
export default function Founders(props: FoundersType) {
    const [selectedFounder, setSelectedFounder] = useState<string>("")

    return (
        <BaseSection classProps="justify-center flex-col sm:flex-row relative items-center px-1" width="w-full" paddings="py-16 ">
            <div
                className={`absolute h-[90vh] sm:w-1/2 left-0 bg-black/50 z-30`}
                onMouseEnter={() => setSelectedFounder("niklas")}
                onMouseLeave={() => setSelectedFounder("")}
            />
            <img
                src={API.img + props.image_niklas?.data?.attributes?.url}
                alt="founder_niklasriedel"
                className={`h-96 w-full sm:h-[90vh] sm:w-1/2 object-cover transition-all duration-300 ${
                    selectedFounder === "niklas" ? "grayscale-0 z-20" : "grayscale z-0"
                }`}
            />
            <div
                className={`absolute h-[90vh] sm:w-1/2 right-0 bg-black/50 z-30 `}
                onMouseEnter={() => setSelectedFounder("felix")}
                onMouseLeave={() => setSelectedFounder("")}
            />
            <img
                src={API.img + props.image_felix?.data?.attributes?.url}
                alt="founder_felixschober"
                className={`h-80 w-full sm:h-[90vh] sm:w-1/2 object-cover transition-all duration-300 ${
                    selectedFounder === "felix" ? "grayscale-0 z-20" : "grayscale z-0"
                }`}
            />
            <SecondaryText blockTextAnimation text="Founders" textSize="text-5xl sm:text-8xl md:text-9xl lg:text-[10rem]" weight="medium" classProps="absolute z-30 translate-y-1/2 sm:translate-y-0" />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: selectedFounder === "niklas" ? 1 : 0 }}
                transition={{ duration: 0.3 }}
                className="z-30 absolute right-[calc(50%+1rem)] bottom-[calc(50%+4rem)] hidden lg:block">
                <p className="text-4xl font-semibold">Niklas Riedel</p>
            </motion.div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: selectedFounder === "felix" ? 1 : 0 }}
                transition={{ duration: 0.3 }}
                className="z-30 absolute left-[calc(50%+1rem)] top-[calc(50%+4rem)] hidden lg:block">
                <p className="text-4xl font-semibold">Felix Schober</p>
            </motion.div>
        </BaseSection>
    )
}
